import {
	getAction
} from '@/api/index';
export default {
	data() {
		return {
			url: {
				productPosterSetting: '/officialWebsite/c-api/setting/productPoster',
				listProductCat: '/officialWebsite/c-api/product/cat/list'
			},
			settingData: {},
			swiper: {
				flag: true, // 用来节流防止重复点击
				offset: 0, //轮播图盒子的偏移值
				ition: 0.8, //设置轮播图过渡时间
				imgShow: 0, //表示当前显示的图片索引
				timeOut: null, //定时器
			},
			listData: []
		}
	},
	computed: {
		mediaLength() {
			if(this.settingData && this.settingData.mediaLst) {
				return this.settingData.mediaLst.length;
			}
			return 0;
		},
	},
	mounted() {
		this.loadData();
	},
	activated() {
		if(this.settingData && this.settingData.mediaLst 
			&& this.settingData.mediaLst.length > 0
			&& this.settingData.mediaLst[this.swiper.imgShow].videoUrl) {
			let videoDom = document.getElementById('poster-video-player' + this.swiper.imgShow);
			if(videoDom && videoDom.paused) videoDom.play();
		}
	},
	methods: {
		loadData() {
			this.loadSetting();
			this.loadProductCatList();
		},
		async loadSetting() {
			const res = await getAction(this.url.productPosterSetting);
			if (res.success) {
				this.settingData = res.result;
				this.$nextTick(() => {
					this.autoRun();
				});
			}
		},
		async loadProductCatList() {
			const res = await getAction(this.url.listProductCat);
			if(res.success) {
				this.listData = res.result;
				if(this.onProductCatLoaded) this.onProductCatLoaded();
			}
		},
		onclickMenuClick(idx) {
			if(this.settingData.mediaLst[this.swiper.imgShow].videoUrl) {
				let videoDom = document.getElementById('poster-video-player' + this.swiper.imgShow);
				if(videoDom) videoDom.pause();
			}
			this.throttle(this.changeFun, idx);
			this.autoRun();
		},
		onloadedmetadata(idx) {
			this.$set(this.settingData.mediaLst[idx], 'loaded', true);
		},
		onVideoEnded(idx) {
			this.throttle(this.nextFun);
			this.autoRun();
		},
		autoRun() {
			if(this.swiper.timeOut) {
				clearTimeout(this.swiper.timeOut)
			}
			if(this.settingData.mediaLst[this.swiper.imgShow].videoUrl) {
				let videoDom = document.getElementById('poster-video-player' + this.swiper.imgShow);
				if(videoDom) {
					videoDom.currentTime = 0;
					videoDom.play();
				}
				return;
			}
			this.swiper.timeOut = setTimeout(() => {
				this.throttle(this.nextFun);
				this.autoRun();
			}, 4000)
		},
		// 这里通过额外封装的节流函数触发 PrevFun() 和 NextFun(),以达到防止重复点击的效果
		throttle(fun, param) {
			if (this.swiper.flag) {
				this.swiper.flag = false;
				fun(param);
				setTimeout(() => {
					this.swiper.flag = true;
				}, 500)
			}
		},
		changeFun(imgShow) {
			this.swiper.imgShow = imgShow;
			this.swiper.offset = '-' + (this.swiper.imgShow * 100) + '%';
		},
		prevFun() {
			if (this.swiper.imgShow != 0) {
				// 判断显示的图片 不是 第一张时执行
				this.swiper.imgShow--;
			} else {
				this.swiper.imgShow = this.mediaLength - 1;
			}
			this.swiper.offset = '-' + (this.swiper.imgShow * 100) + '%';
		},
		nextFun() {
			if (this.swiper.imgShow < this.mediaLength - 1) {
				// 判断显示的图片 不是 最后一张时执行
				this.swiper.imgShow++;
			} else {
				this.swiper.imgShow = 0;
			}
			this.swiper.offset = '-' + (this.swiper.imgShow * 100) + '%';
		},
		onClickItem(id) {
			this.$router.push({
				path: '/detail?type=product&id=' + id
			});
		},
		onPosterClick(item) {
			if(item.linkUrl) {
				const id = 'url_poster'+item.sortNo;
				var a = document.createElement('a');
				a.setAttribute('href', item.linkUrl);
				a.setAttribute('target', '_blank');
				a.setAttribute('id', id);
				// 防止反复添加
				if(!document.getElementById(id)) document.body.appendChild(a);
				a.click();
				document.getElementById(id).remove();
			}
			
		}
	}
}